// extracted by mini-css-extract-plugin
export default {"card":"UserCard_card__XICja","avatar":"UserCard_avatar__YwmqW"};